module.exports = "/virtual-football-league/img/video/clubs/italy/roma.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/italy/roma.png
// module id = 352
// module chunks = 4